export const environment = {
  appTitle: 'Dev - Zhylar',
  BASE_PATH: 'https://api.development.zhylar.com',
  FRONTEND_DOMAIN: 'https://dev.zhylar.com',
  RECAPTCHA_SITE_KEY: '6Lci_uorAAAAAJR_cqPomJkPnSOWFJxxwNowjY2L',
  firebaseConfig: {
    apiKey: 'AIzaSyBOLVCIMTq3AfnTUM1FwNEcp-MPu7anfJQ',
    authDomain: 'zhylar-development.firebaseapp.com',
    projectId: 'zhylar-development',
    storageBucket: 'zhylar-development.firebasestorage.app',
    messagingSenderId: '11390238620',
    appId: '1:11390238620:web:7d946c6c3a06958f4bd259',
  },
  vapidKey: 'BMCZSBr3kFW1c9PJffQFCJxRafmJ6knWC2Q7O1xVA_4a5Pp-njepUasIF04Mn58xRPAIVpAits_pqwnSv0eJYUk',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_51SzY5qJYXeSiyOmOvQB6aPCqtXYGTQCGhORbjjQPzbcTEbVYmJZ1xOoN4DRTmTN0ZJXaWWJPwAxpmuUq0QdqPiEB00hH8SXeRN',
};
